var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "analytics (22) 1",
    clipPath: "url(#clip0_555_384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.8852 48.1758H25.0645V50.0563H27.8852V48.1758Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M56.0927 0.222656H5.3185C2.7262 0.222656 0.617188 2.33167 0.617188 4.92397V45.3553C0.617188 47.9476 2.7262 50.0566 5.3185 50.0566H10.0198V48.176H5.3185C3.76331 48.176 2.49771 46.9105 2.49771 45.3553V9.62528H58.9135V45.3553C58.9135 46.9105 57.6479 48.176 56.0927 48.176V50.0566C58.685 50.0566 60.794 47.9476 60.794 45.3553V4.92397C60.794 2.33167 58.685 0.222656 56.0927 0.222656ZM58.9135 7.74476H2.49771V4.92397C2.49771 3.36877 3.76331 2.10318 5.3185 2.10318H56.0927C57.6479 2.10318 58.9135 3.36877 58.9135 4.92397V7.74476Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.31819 5.8649C5.83748 5.8649 6.25845 5.44393 6.25845 4.92464C6.25845 4.40534 5.83748 3.98438 5.31819 3.98438C4.7989 3.98438 4.37793 4.40534 4.37793 4.92464C4.37793 5.44393 4.7989 5.8649 5.31819 5.8649Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.07991 5.8649C9.5992 5.8649 10.0202 5.44393 10.0202 4.92464C10.0202 4.40534 9.5992 3.98438 9.07991 3.98438C8.56062 3.98438 8.13965 4.40534 8.13965 4.92464C8.13965 5.44393 8.56062 5.8649 9.07991 5.8649Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.8407 5.8649C13.3599 5.8649 13.7809 5.44393 13.7809 4.92464C13.7809 4.40534 13.3599 3.98438 12.8407 3.98438C12.3214 3.98438 11.9004 4.40534 11.9004 4.92464C11.9004 5.44393 12.3214 5.8649 12.8407 5.8649Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M49.5107 37.8319H43.8691V34.0709C43.8691 33.5519 43.4479 33.1306 42.9289 33.1306H30.7628C31.3251 31.6685 31.6457 30.087 31.6457 28.4293C31.6457 27.9103 31.2245 27.489 30.7054 27.489H19.4223V16.2059C19.4223 15.6869 19.0011 15.2656 18.482 15.2656C11.2232 15.2656 5.31836 21.1705 5.31836 28.4293C5.31836 35.6881 11.2232 41.593 18.482 41.593C23.3413 41.593 27.5847 38.9386 29.8649 35.0111H41.9886V37.8319H34.4665C31.8742 37.8319 29.7652 39.9409 29.7652 42.5332V51.9359C29.7652 54.5282 31.8742 56.6372 34.4665 56.6372H49.5107C52.103 56.6372 54.212 54.5282 54.212 51.9359V42.5332C54.212 39.9409 52.103 37.8319 49.5107 37.8319ZM7.19888 28.4293C7.19888 22.5245 11.7592 17.6642 17.5418 17.1856V28.2412L13.2937 38.4375C9.67742 36.556 7.19888 32.7799 7.19888 28.4293ZM28.7262 33.1306H24.8899C24.5007 32.039 23.4664 31.2501 22.2421 31.2501C20.687 31.2501 19.4214 32.5157 19.4214 34.0709C19.4214 35.6261 20.687 36.8917 22.2421 36.8917C23.4664 36.8917 24.5007 36.1028 24.8899 35.0111H27.6317C25.581 37.8536 22.2468 39.7125 18.482 39.7125C17.2766 39.7125 16.1163 39.5178 15.0266 39.1662L19.1092 29.3696H29.7257C29.6147 30.7038 29.2621 31.9675 28.7262 33.1306ZM23.1833 34.0709C23.1833 34.589 22.7612 35.0111 22.2431 35.0111C21.725 35.0111 21.3028 34.589 21.3028 34.0709C21.3028 33.5528 21.725 33.1306 22.2431 33.1306C22.7612 33.1306 23.1833 33.5528 23.1833 34.0709ZM52.3315 51.9359C52.3315 53.4911 51.0659 54.7567 49.5107 54.7567H34.4665C32.9113 54.7567 31.6457 53.4911 31.6457 51.9359V42.5332C31.6457 40.978 32.9113 39.7125 34.4665 39.7125H49.5107C51.0659 39.7125 52.3315 40.978 52.3315 42.5332V51.9359Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M35.4067 11.5039C35.1575 11.5039 34.9177 11.6026 34.7419 11.7794L31.3429 15.1785C28.9762 12.9087 25.7737 11.5039 22.243 11.5039C21.724 11.5039 21.3027 11.9251 21.3027 12.4442V24.6676C21.3027 25.1866 21.724 25.6078 22.243 25.6078H34.4664C34.9854 25.6078 35.4067 25.1866 35.4067 24.6676C35.4067 21.6164 34.3536 18.8107 32.6047 16.5757L35.7959 13.3844H40.108V11.5039H35.4067ZM33.4867 23.7273H23.1833V13.4239C25.8226 13.643 28.2014 14.7807 30.0143 16.507L28.1601 18.3612L29.4896 19.6908L31.2648 17.9156C32.5031 19.5648 33.3071 21.5572 33.4867 23.7273Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M57.0325 11.5039H41.9883V13.3844H57.0325V11.5039Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M57.0325 15.2656H41.9883V17.1462H57.0325V15.2656Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M57.0325 19.0273H41.9883V20.9079H57.0325V19.0273Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M23.1838 58.518V49.1154C23.1838 48.5964 22.7626 48.1751 22.2436 48.1751H18.4825V45.3543C18.4825 44.8353 18.0613 44.4141 17.5422 44.4141H12.8409C12.3219 44.4141 11.9007 44.8353 11.9007 45.3543V52.8764H8.13962C7.6206 52.8764 7.19936 53.2977 7.19936 53.8167V58.518H2.49805V60.3985H8.13962H12.8409H17.5422H22.2436H26.9449V58.518H23.1838ZM11.9007 58.518H9.07988V54.757H11.9007V58.518ZM16.602 49.1154V58.518H13.7812V53.8167V46.2946H16.602V49.1154ZM21.3033 58.518H18.4825V50.0556H21.3033V58.518Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M48.619 43.1766L46.4451 49.7001L41.8557 42.0502C41.6742 41.7474 41.348 41.5716 40.986 41.596C40.6334 41.6195 40.325 41.8386 40.1858 42.1639L37.9122 47.4698L36.0731 45.6307C35.8502 45.4078 35.5306 45.3119 35.2193 45.3749C34.91 45.4379 34.6524 45.6532 34.5348 45.9466L32.6543 50.6479L34.3994 51.3465L35.7506 47.9691L37.5634 49.7819C37.7844 50.0029 38.0994 50.0997 38.4059 50.0405C38.7124 49.9822 38.97 49.7744 39.0923 49.4876L41.1891 44.5954L45.8847 52.4212C46.0549 52.7061 46.3614 52.8773 46.6896 52.8773C46.7234 52.8773 46.7582 52.8754 46.7921 52.8716C47.1569 52.8321 47.4653 52.582 47.5819 52.2341L50.4027 43.7718L48.619 43.1766Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M56.0929 24.668H46.6903C46.1712 24.668 45.75 25.0892 45.75 25.6082V33.1303C45.75 33.6494 46.1712 34.0706 46.6903 34.0706H56.0929C56.6119 34.0706 57.0332 33.6494 57.0332 33.1303V25.6082C57.0332 25.0892 56.6119 24.668 56.0929 24.668ZM53.4122 26.5485L51.3916 28.1657L49.37 26.5485H53.4122ZM47.6305 27.564L49.8872 29.3693L47.6305 31.1746V27.564ZM49.37 32.1901L51.3916 30.5728L53.4131 32.1901H49.37ZM55.1526 31.1736L52.896 29.3693L55.1526 27.564V31.1736Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_555_384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.1768,
    height: 60.1768,
    fill: "white",
    transform: "translate(0.617188 0.222656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.4b36bdc6597a3a7a440fbaa6e2e675b2.svg";
export { ForwardRef as ReactComponent };